import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Report3 extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
    this.isSimplified = true;
  }

  get year() {
    return get(this, '_rok.value', '');
  }

  get period() {
    return get(this, '_kwartal.value[0].codename', '');
  }

  get quarter() {
    let quarter = get(this, '_kwartal.value[0].name', '');
    switch (quarter) {
      case 'Q1':
        quarter = '1';
        break;
      case 'Q2':
        quarter = '2';
        break;
      case 'Q3':
        quarter = '3';
        break;
      case 'Q4':
        quarter = '4';
        break;
      default:
        quarter = 'Roczny';
    }
    return quarter;
  }

  get reportImage() {
    return get(this, '_miniaturka.value[0].url', '');
  }

  get prevYear() {
    return this.year - 1;
  }

  get nextYear() {
    return this.year + 1;
  }

  get pdfUrl() {
    return get(this, '_raport_pdf.value', '[]');
  }

  get reportFile() {
    return get(this, '_plik_raportu.value[0]', null);
  }

  get hasReportFile() {
    return !!this.reportFile;
  }
}



// WEBPACK FOOTER //
// ./src/models/Report3.js